var _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRightThin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "339.63 311.95 5 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "currentColor",
    points: "339.63 313.18 339.63 311.95 344.63 316.95 339.63 321.95 339.63 320.72 343.4 316.95 339.63 313.18"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRightThin);
export default __webpack_public_path__ + "static/media/chevron-right-thin.1cb4b5c66c973cf3b3bd96300511b637.svg";
export { ForwardRef as ReactComponent };